import { Volume } from '@/api/type-server'
import { Radio, Trans } from '@/components'
import { cn } from '@/utils/style'
import { volumeUsage } from '@/utils/volume'

interface VolumeSelectorProps {
  values?: Volume[]
  value?: Volume
  machineDomains?: number[]
  onChange: (value?: Volume) => void
}

export function VolumeSelector({ values, value, machineDomains, onChange }: VolumeSelectorProps) {
  return (
    <div>
      <h3 className="text-primary mb-4">
        <Trans i18nKey="create.volumeSelectorDataDrive">Data Hub</Trans>
      </h3>
      <table className="table mt-4">
        <thead>
          <tr>
            <th></th>
            {/* <th>
              <Trans i18nKey="create.volumeTableHeaderID">ID</Trans>
            </th> */}
            <th>
              <Trans i18nKey="create.volumeTableHeaderRegion">Region</Trans>
            </th>
            <th>
              <Trans i18nKey="create.volumeTableHeaderUsage">Usage</Trans>
            </th>
          </tr>
        </thead>
        <tbody>
          {values?.map((vol) => {
            const usage = volumeUsage(vol)
            return (
              <tr
                key={vol.id}
                className={cn('cursor-pointer', {
                  'bg-panel-gray-100': value?.id === vol.id,
                })}
                onClick={() => {
                  if (!machineDomains?.includes(vol.domain)) return
                  onChange(vol)
                }}
              >
                <td className="w-5">
                  <Radio
                    checked={value?.id === vol.id}
                    onChange={() => onChange(vol)}
                    disabled={machineDomains?.includes(vol.domain) === false}
                  />
                </td>
                {/* <td>
                  <div className="text-primary t-sb">{vol.id}</div>
                </td> */}
                <td>
                  <div className="text-primary t-sb">
                    <Trans i18nKey={`common.region.domain${vol.domain}`}>Region</Trans>
                  </div>
                </td>
                <td>
                  <div className="text-primary t-sb flex">
                    {usage.usage}
                    <div className="text-tertiary">
                      /{usage.total}
                      {usage.unit}
                    </div>
                  </div>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
